import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxState from '../../cx/CxState';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import { getStoreValue, setStoreValue } from "../../gx/GxStore";
import GxForm from '../../gx/GxForm';

const MxSettCommGeneral = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const r_snack_save = React.useRef(null);
  const r_snack_send_wa_daily = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txUserToShowCommDlg = React.useRef(null);
  const rf_txEmailForComm = React.useRef(null);
  const rf_boDisableCommDlg = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    Promise.all([FxFetch.doJsonX('sett/app/r', record)]).then((result) => {
      if (result[0]) {
        FxLog.infox('MxSettCommGeneral.formLoad', '...result[0]:', result[0]);
        rf_boDisableCommDlg.current.setVal(result[0][0].boDisableCommDlg);
        rf_txUserToShowCommDlg.current.setKey(result[0][0].inUserToShowCommDlg);
        rf_txUserToShowCommDlg.current.setKeyAndVal("n_user", "txUser", "inUser", result[0][0].inUserToShowCommDlg);
        rf_txEmailForComm.current.setKey(result[0][0].itEmailForComm);
        rf_txEmailForComm.current.setKeyAndVal("t_email", "txName", "itEmail", result[0][0].itEmailForComm);
      }
    });
  }

  const formSaveCustom = async () => {
    let filter = { "inBranch": getStoreValue('StoreSession', 'inBranch'), };
    let record = {};
    record['txScopeKey'] = "BRANCH"; record['txScopeVal'] = getStoreValue('StoreSession', 'inBranch');    
    record['inUserToShowCommDlg'] = rf_txUserToShowCommDlg.current.getKey();
    record['itEmailForComm'] = rf_txEmailForComm.current.getKey();
    record['boDisableCommDlg'] = rf_boDisableCommDlg.current.getVal();
    
    setStoreValue('StoreSession', 'boDisableCommDlg', rf_boDisableCommDlg.current.getVal());
    setStoreValue('StoreSession', 'inUserToShowCommDlg', rf_txUserToShowCommDlg.current.getKey());
    setStoreValue('StoreSession', 'itEmailForComm', rf_txEmailForComm.current.getKey());
    
    Promise.all([FxFetch.doJsonF("sett/app/u", filter, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current.setOpen(true);
        }
      }
    });

    r_snack_save.current.setOpen(true);
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.comms')} - ${trans('field.general')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >

        <CxState mode='checkbox' xref={rf_boDisableCommDlg} 
          label={`${trans('field.popup_window')}-${trans('field.disable')}`} 
          onChange={(id, newValue) => { if (newValue==='1') { r_snack_send_wa_daily.current.setOpen(true); } }}
        />

        <CxSearcher xref={rf_txUserToShowCommDlg} label={`${trans('field.popup_window')}-${trans('field.user')}`}
          url="sett/sec/users"
          col_id="inUser"
          col_tx="txUser"
          columns={[
            { id: "0", Header: "ID", accessor: "inUser", show: false },
            { id: "1", Header: trans('field.user'), accessor: row => rf_txUserToShowCommDlg.current.getTable().highlightText(row["txUser"]), width: '100%' },
          ]}
          width="var(--ibs_control_width_lg)"
        />

        <CxSearcher xref={rf_txEmailForComm} label={trans('field.comm_email')}
          url="sett/email"
          col_id="itEmail"
          col_tx="txName"
          columns={[
            { id: "0", Header: "ID", accessor: "itEmail", show: false },
            { id: "1", Header: trans('field.name'), accessor: row => rf_txEmailForComm.current.getTable().highlightText(row["txName"]), width: '100%' },
          ]}
          width="var(--ibs_control_width_lg)"
        />

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_send_wa_daily} severity="info" value={trans('msg.send_wa_daily')} autoHideDuration={4000} />
      
    </div>
  );

}

export default MxSettCommGeneral;